import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {
contactForm!: FormGroup;
  submitted = false;
  ShowCard:any;
   selectedTab: string = 'ownership'; // default tab



constructor(private fb: FormBuilder,private titleService: Title, private metaService: Meta,
  private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private router:Router
) {}

  ngOnInit(): void {
    this.setMetaTags();
    this.setCanonicalUrl();
//  this.titleService.setTitle('FA Check | About Us');
//     this.metaService.updateTag({
//       name: 'description',
//       content: 'Get to know FA Check, your partner in secure verification and streamlined compliance for modern business operations.'
//     });

    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  get f() { return this.contactForm.controls; }

  onSubmit(): void {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }
    console.log('Form Submitted:', this.contactForm.value);
    alert('Thank you! Your message has been sent.');
    this.contactForm.reset();
    this.submitted = false;
  }
 private setMetaTags(): void {
        // Set page title (works for both server and client)
        this.titleService.setTitle('FA Check | About Us');
       
        // Update or add meta tags
        this.metaService.updateTag({ name: 'description', content: 'Get to know FA Check, your partner in secure verification and streamlined compliance for modern business operations.' });
        // this.metaService.updateTag({ name: 'author', content: 'Your Name' });
       
        // For keywords, use updateTag with proper attribute
//         this.metaService.updateTag({ name: 'keywords', content: 'Association Management Solution, Association Management Software, Best Association Management Solution'
//  });
       
        // Open Graph tags
        this.metaService.updateTag({ property: 'og:title', content: 'FA Check | About Us' });
        this.metaService.updateTag({ property: 'og:description', content: 'Get to know FA Check, your partner in secure verification and streamlined compliance for modern business operations.' });
        this.metaService.updateTag({ property: 'og:url', content: `https://facheck.in${this.router.url}` });
        this.metaService.updateTag({ property: 'og:type', content: 'website' });
       
        // Twitter tags
        this.metaService.updateTag({ name: 'twitter:title', content: 'FA Check | About Us' });
        this.metaService.updateTag({ name: 'twitter:description', content: 'Get to know FA Check, your partner in secure verification and streamlined compliance for modern business operations.' });
        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
       
        // You can also add tags if they don't exist
        // this.addTagIfNotExists('og:image', { property: 'og:image', content: 'https://quickrentpay.com/assets/images/og-image.jpg' });
        // this.addTagIfNotExists('twitter:image', { name: 'twitter:image', content: 'https://quickrentpay.com/assets/images/twitter-image.jpg' });
    }
 
 setCanonicalUrl(): void {
    // Remove query parameters for clean canonical URL
    const cleanUrl = this.router.url.split('?')[0];
    const canonicalUrl = `https://facheck.in${cleanUrl}`;
   
    // Use the same DOM manipulation on both server and client
    this.updateCanonicalLink(canonicalUrl);
  }
 
  private updateCanonicalLink(url: string): void {
    // Find existing canonical link
    const existingLink = this.document.querySelector("link[rel='canonical']");
   
    if (existingLink) {
      // Update existing link if href is different
      const currentHref = existingLink.getAttribute('href');
      if (currentHref !== url) {
        this.renderer.setAttribute(existingLink, 'href', url);
      }
    } else {
      // Create new canonical link if it doesn't exist
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(this.document.head, link);
    }
  }
}
